<template>
	<div class="personHome">
		<!-- 左侧产品列表 -->
		<div class="psLeftContent">
			<!-- 消息 -->
			<div class="item w100">
				<div class="text bd10 p3">
					<div class="sTitle d-flex a-center j-sb">
						<div class="leftText">
							 <h3 class="font20">{{content.title}}</h3>
							 <p class="font-light cor999">{{content.time}}</p>
						</div>
						<div class="btns d-flex a-center">
							<a class="d line-sm font-light cor999" @click="delMessage">{{$t('admin.del')}}</a>
						    <a href="javascript:;" class="link font-light cor999" @click="$router.go(-1);">{{$t('admin.back')}} &gt;</a>
						</div>
					</div>
					<div class="detail line-md font-light">
						<div v-html="content.content"></div>
					</div>
				</div>
			</div>
		</div>
		
	</div>
</template>

<script>
export default {
  name: 'MessageDetail',
  components: {
    
  },
  data() {
    return {
		itemid:"",
		content:""
	}
  },
  created:function(){
	this.itemid=this.$route.query.id;
	this.getContent(this.itemid);
  },
  methods:{
	getContent(id){
		this.$axios
        .get(`member/messageDetails?id=${id}`)
        .then((res) => {
          this.content = res.data;
        })
        .catch((err) => {});
	},
	delMessage(){
		this.$axios
        .get(`member/deleteMessage?id=${this.itemid}`)
        .then((res) => {
          if(res.code==200){
			this.$message({
				message: this.$t('commom.deleteSucess'),
				type:'success'
			});
			this.$router.push({
				path:'/messageList'
			});
		  }
        })
        .catch((err) => {});
	}
  }
}
</script>

<style lang="less" scoped>
	.personHome{
		
		.psLeftContent{
			.leftText p{
				margin-top: .15rem;
			}
			.sTitle{
				padding-bottom: .3rem;
				margin-bottom: .3rem;
				border-bottom: solid 1px #eee;
				.d{
					padding-left: .3rem;
					margin-right: .2rem;
					color: #999;
					background: url(@/assets/Icons/deletGray.png) no-repeat 0 center/.18rem;
					cursor: pointer;
					&:hover{
						color: #2657db;
						background-image: url(@/assets/Icons/deletBlue.png);
					}
				}
			}
		}
		@media (max-width: 640px) {
			padding: .2rem;
		}
	}
</style>
